import { render, staticRenderFns } from "./RentalLinkList.vue?vue&type=template&id=670813a4&"
import script from "./RentalLinkList.vue?vue&type=script&lang=js&"
export * from "./RentalLinkList.vue?vue&type=script&lang=js&"
import style0 from "./RentalLinkList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports